import './App.css';
import AppRoutes from './routes/routes';
import './common.css'
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { AccessProvider } from './context/AccessContext';

import ErrorBoundary from './components/ui/ErrorBoundary';

function App() {
  return (
    <ErrorBoundary>
      <AccessProvider>
        <div >
            <AppRoutes></AppRoutes>
            <ToastContainer/>
        </div>
      </AccessProvider>
    </ErrorBoundary>
  );
}

export default App;
